import {
  hasUserRole,
  hasSystem,
  hasPermission,
} from './sharedRulesEvaluatorHelper';

//Why import this here instead of in the shared file which I'm passing it to?
//Because.  That's why.  ok... really I'm doing it because the idea of the
//sharedRulesEvaluator is that we are going to eliminate some functions
//from the rulesEvaluator in favor of some of them in the
//sharedRulesEvaluatorHelper, and so since we are living in abstract land with
//these, I'll pass the one I care about from here, and the rulesEvaluator one
//can pass the one it cares about (if it ever needs it)
import { PartnerPermissionLevel } from 'data/masterdata';

export default function partnerRulesEvaluator(
  partner,
  roles,
  permissions = []
) {
  const { nonCentralizedProductsEnabled: partnerCanSellLegacy, systems } =
    partner ?? {};

  function checkIfDrawerItemIncluded(item) {
    // Some drawer items are only shown based on if the partner is able
    // to sell legacy products. This only runs if the user is _not_ a super
    // admin. If they're a super admin, they will see this item.
    if (
      item.onlyIfPartnerCanSellLegacy !== undefined &&
      item.onlyIfPartnerCanSellLegacy
    ) {
      // Must have "can sell legacy" and Can Access TWP Portal permission
      return (
        partnerCanSellLegacy &&
        hasUserRole(item?.roles, roles) &&
        hasSystem(item?.systems, systems) &&
        hasPermission(item?.permissions, permissions, PartnerPermissionLevel)
      );
    }

    return (
      hasUserRole(item?.roles, roles) &&
      hasSystem(item?.systems, systems) &&
      hasPermission(item?.permissions, permissions, PartnerPermissionLevel)
    );
  }

  function checkIfTopAppBarItemIncluded(item) {
    const requireRoleCheck = Array.isArray(item?.roles);

    if (!requireRoleCheck) {
      return hasPermission(
        item?.permissions,
        permissions,
        PartnerPermissionLevel
      );
    }

    if (requireRoleCheck) {
      return (
        hasUserRole(item?.roles, roles) &&
        hasPermission(item?.permissions, permissions, PartnerPermissionLevel)
      );
    }

    return false;
  }

  return {
    checkIfDrawerItemIncluded,
    checkIfTopAppBarItemIncluded,
  };
}
